/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d2b13ad2a2fe6e5fadc4e65812219bf7>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const ListBulletedIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" d="M2.75 2.75a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/><path stroke="currentcolor" stroke-width="1.5" d="M5 2.75h10M5 8h10M5 13.25h10M2.75 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0-10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
ListBulletedIcon.displayName = 'ListBulletedIcon';
var _default = exports.default = ListBulletedIcon;